"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorType = void 0;
var ActorType;
(function (ActorType) {
    ActorType[ActorType["None"] = 0] = "None";
    // Character Classes
    ActorType[ActorType["Warrior"] = 1] = "Warrior";
    ActorType[ActorType["Vampire"] = 2] = "Vampire";
    ActorType[ActorType["Valkyrie"] = 3] = "Valkyrie";
    ActorType[ActorType["HighPriestess"] = 4] = "HighPriestess";
    ActorType[ActorType["Augur"] = 5] = "Augur";
    ActorType[ActorType["Assassin"] = 6] = "Assassin";
    ActorType[ActorType["Avenger"] = 7] = "Avenger";
    ActorType[ActorType["TheTribunal"] = 8] = "TheTribunal";
    ActorType[ActorType["Tempest"] = 9] = "Tempest";
    ActorType[ActorType["Executioner"] = 10] = "Executioner";
    ActorType[ActorType["Ranger"] = 11] = "Ranger";
    ActorType[ActorType["Sunbreaker"] = 12] = "Sunbreaker";
    ActorType[ActorType["ThunderCaller"] = 13] = "ThunderCaller";
    ActorType[ActorType["Druid"] = 14] = "Druid";
    ActorType[ActorType["Monk"] = 15] = "Monk";
    ActorType[ActorType["Gladiator"] = 16] = "Gladiator";
    ActorType[ActorType["Necromancer"] = 17] = "Necromancer";
    ActorType[ActorType["Gambler"] = 18] = "Gambler";
    ActorType[ActorType["WarriorJoe"] = 19] = "WarriorJoe";
    ActorType[ActorType["NecromancerMale"] = 20] = "NecromancerMale";
    ActorType[ActorType["BuddyThePenguin"] = 21] = "BuddyThePenguin";
    ActorType[ActorType["Magician"] = 22] = "Magician";
    ActorType[ActorType["Bard"] = 23] = "Bard";
    ActorType[ActorType["Mechanist"] = 24] = "Mechanist";
    ActorType[ActorType["Cleric"] = 25] = "Cleric";
    ActorType[ActorType["TimeKeeper"] = 26] = "TimeKeeper";
    // Companion/Pet Classes
    ActorType[ActorType["RangerPet"] = 500] = "RangerPet";
    ActorType[ActorType["AugurSoul"] = 501] = "AugurSoul";
    ActorType[ActorType["Snowman"] = 502] = "Snowman";
    ActorType[ActorType["GreaterElementalServant"] = 504] = "GreaterElementalServant";
    ActorType[ActorType["MechanistTurret"] = 505] = "MechanistTurret";
    // Magician Crystal Classes
    ActorType[ActorType["Magician_SonicCrystal"] = 600] = "Magician_SonicCrystal";
    ActorType[ActorType["Magician_FireCrystal"] = 601] = "Magician_FireCrystal";
    ActorType[ActorType["Magician_FrostCrystal"] = 602] = "Magician_FrostCrystal";
    ActorType[ActorType["Magician_NatureCrystal"] = 603] = "Magician_NatureCrystal";
    // Ally AI Classes
    ActorType[ActorType["Hammer"] = 1000] = "Hammer";
    ActorType[ActorType["Archangel"] = 1001] = "Archangel";
    ActorType[ActorType["NecromancerSkeleton"] = 1002] = "NecromancerSkeleton";
    ActorType[ActorType["NecromancerLich"] = 1003] = "NecromancerLich";
    ActorType[ActorType["NecromancerSpirit"] = 1004] = "NecromancerSpirit";
    ActorType[ActorType["NecromancerReaper"] = 1005] = "NecromancerReaper";
    ActorType[ActorType["GamblerBouncer"] = 1006] = "GamblerBouncer";
    ActorType[ActorType["TempestMirror"] = 1007] = "TempestMirror";
    ActorType[ActorType["Caravan"] = 1008] = "Caravan";
    ActorType[ActorType["Mischief"] = 1009] = "Mischief";
    ActorType[ActorType["MagicianMirage"] = 1010] = "MagicianMirage";
    // Enemies
    ActorType[ActorType["SkeletonPunchingBag"] = 100000] = "SkeletonPunchingBag";
    ActorType[ActorType["Skeleton"] = 100001] = "Skeleton";
    ActorType[ActorType["SkeletalMage"] = 100002] = "SkeletalMage";
    ActorType[ActorType["Crab"] = 100003] = "Crab";
    ActorType[ActorType["SeaTurtle"] = 100004] = "SeaTurtle";
    ActorType[ActorType["Toucan"] = 100005] = "Toucan";
    ActorType[ActorType["Slug"] = 100006] = "Slug";
    ActorType[ActorType["Shade"] = 100007] = "Shade";
    ActorType[ActorType["Thief"] = 100008] = "Thief";
    ActorType[ActorType["Bandit"] = 100009] = "Bandit";
    ActorType[ActorType["DockWorker"] = 100010] = "DockWorker";
    ActorType[ActorType["OrcPawn"] = 100011] = "OrcPawn";
    ActorType[ActorType["OrcHuntsman"] = 100012] = "OrcHuntsman";
    ActorType[ActorType["OrcShaman"] = 100013] = "OrcShaman";
    ActorType[ActorType["OrcWarchief"] = 100014] = "OrcWarchief";
    ActorType[ActorType["OrcCenturion"] = 100015] = "OrcCenturion";
    ActorType[ActorType["CityGuard"] = 100016] = "CityGuard";
    ActorType[ActorType["Knight"] = 100017] = "Knight";
    ActorType[ActorType["Templar"] = 100018] = "Templar";
    ActorType[ActorType["CircusMonkey"] = 100019] = "CircusMonkey";
    ActorType[ActorType["CircusCombatant"] = 100020] = "CircusCombatant";
    ActorType[ActorType["CircusJester"] = 100021] = "CircusJester";
    ActorType[ActorType["Werewolf"] = 100022] = "Werewolf";
    ActorType[ActorType["Spider"] = 100023] = "Spider";
    ActorType[ActorType["EvilTreant"] = 100024] = "EvilTreant";
    ActorType[ActorType["DruidOfTheGrove"] = 100025] = "DruidOfTheGrove";
    ActorType[ActorType["SorcerorOfBane"] = 100026] = "SorcerorOfBane";
    ActorType[ActorType["KnightOfBane"] = 100027] = "KnightOfBane";
    ActorType[ActorType["GuardianOfBane"] = 100028] = "GuardianOfBane";
    ActorType[ActorType["MountainGiant"] = 100029] = "MountainGiant";
    ActorType[ActorType["FireElemental"] = 100030] = "FireElemental";
    ActorType[ActorType["FrostElemental"] = 100031] = "FrostElemental";
    ActorType[ActorType["EarthElemental"] = 100032] = "EarthElemental";
    ActorType[ActorType["EnergizedElemental"] = 100033] = "EnergizedElemental";
    ActorType[ActorType["BasiliskSnake"] = 100034] = "BasiliskSnake";
    ActorType[ActorType["Chicken"] = 100035] = "Chicken";
    ActorType[ActorType["SpectralBat"] = 100036] = "SpectralBat";
    ActorType[ActorType["Anomaly"] = 100037] = "Anomaly";
    ActorType[ActorType["ReanimatedZombieHand"] = 100038] = "ReanimatedZombieHand";
    ActorType[ActorType["ArmoredMammoth"] = 100039] = "ArmoredMammoth";
    ActorType[ActorType["Boggart"] = 100040] = "Boggart";
    ActorType[ActorType["Golem"] = 100041] = "Golem";
    ActorType[ActorType["Ooze"] = 100042] = "Ooze";
    ActorType[ActorType["WolfShaman"] = 100043] = "WolfShaman";
    ActorType[ActorType["WarElephant"] = 100044] = "WarElephant";
    ActorType[ActorType["GenieArtifact"] = 100045] = "GenieArtifact";
    ActorType[ActorType["WildBoar"] = 100047] = "WildBoar";
    ActorType[ActorType["SpringHare"] = 100049] = "SpringHare";
    ActorType[ActorType["BlackSpider"] = 100050] = "BlackSpider";
    ActorType[ActorType["RedSpider"] = 100051] = "RedSpider";
    ActorType[ActorType["Bear"] = 100052] = "Bear";
    ActorType[ActorType["Capybara"] = 100053] = "Capybara";
    ActorType[ActorType["FloatingEye"] = 100054] = "FloatingEye";
    ActorType[ActorType["Ghost"] = 100055] = "Ghost";
    ActorType[ActorType["PirateSwashbuckler"] = 100056] = "PirateSwashbuckler";
    ActorType[ActorType["PirateGunner"] = 100057] = "PirateGunner";
    ActorType[ActorType["PirateMystic"] = 100058] = "PirateMystic";
    ActorType[ActorType["CentaurArcher"] = 100059] = "CentaurArcher";
    ActorType[ActorType["CentaurWarrior"] = 100060] = "CentaurWarrior";
    ActorType[ActorType["CentaurMedic"] = 100061] = "CentaurMedic";
    ActorType[ActorType["LivingTreasure"] = 100062] = "LivingTreasure";
    // Enemy Companion/Pet Classes
    ActorType[ActorType["ShroudOfImmortality"] = 200000] = "ShroudOfImmortality";
    ActorType[ActorType["DragonWhelp"] = 200001] = "DragonWhelp";
    // Bosses
    ActorType[ActorType["RavynTheDamned"] = 300002] = "RavynTheDamned";
    ActorType[ActorType["Hamm"] = 300003] = "Hamm";
    ActorType[ActorType["Xyria"] = 300004] = "Xyria";
    ActorType[ActorType["LadyNyx"] = 300005] = "LadyNyx";
    ActorType[ActorType["CaedecusOfTheArcane"] = 300006] = "CaedecusOfTheArcane";
    ActorType[ActorType["AmbassadorDLere"] = 300007] = "AmbassadorDLere";
    ActorType[ActorType["EmperorMangle"] = 300008] = "EmperorMangle";
    ActorType[ActorType["LordZug"] = 300009] = "LordZug";
    ActorType[ActorType["BanditLieutenant"] = 300010] = "BanditLieutenant";
    ActorType[ActorType["LadyInRed"] = 300011] = "LadyInRed";
    ActorType[ActorType["WaspQueen"] = 300012] = "WaspQueen";
    ActorType[ActorType["ElderTreant"] = 300013] = "ElderTreant";
    ActorType[ActorType["CaptainNorrisGhost"] = 300014] = "CaptainNorrisGhost";
    ActorType[ActorType["MysticGenie"] = 300015] = "MysticGenie";
    ActorType[ActorType["TheWinterKnight"] = 300016] = "TheWinterKnight";
    ActorType[ActorType["RexShadyTodd"] = 300017] = "RexShadyTodd";
    ActorType[ActorType["Stampy"] = 300018] = "Stampy";
    ActorType[ActorType["WildE"] = 300020] = "WildE";
    ActorType[ActorType["CaptainLongshank"] = 300021] = "CaptainLongshank";
    ActorType[ActorType["CentaurChampion"] = 300022] = "CentaurChampion";
    ActorType[ActorType["TheodoreMessengerOfBane"] = 300023] = "TheodoreMessengerOfBane";
    ActorType[ActorType["CorruptedGiant"] = 300024] = "CorruptedGiant";
    ActorType[ActorType["MoltenColossus"] = 300025] = "MoltenColossus";
    ActorType[ActorType["WildECannon"] = 300026] = "WildECannon";
    ActorType[ActorType["CinderDrake"] = 300027] = "CinderDrake";
    ActorType[ActorType["WarWolf"] = 300028] = "WarWolf";
    ActorType[ActorType["Cyndine"] = 300029] = "Cyndine";
    ActorType[ActorType["Cerberus"] = 300030] = "Cerberus";
    ActorType[ActorType["AspectOfKaboom"] = 300031] = "AspectOfKaboom";
    ActorType[ActorType["HeadlessHorseman"] = 300032] = "HeadlessHorseman";
})(ActorType = exports.ActorType || (exports.ActorType = {}));
